// extracted by mini-css-extract-plugin
module.exports = {"outerBox":"ViewAndCode__outerBox__C52A7","tabPaneBox":"ViewAndCode__tabPaneBox__Rsc7k"};